import { useIsVisible } from "@/hooks/use-is-visible";
import { useRef, type ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
};

export function Reveal({ children, className = "" }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useIsVisible(ref, { once: true });

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out motion-reduce:transition-none ${
        isVisible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4"
      } ${className}`}
    >
      {children}
    </div>
  );
}
